import { CreateMapping } from 'Store/common/common.types'
import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  BannerListReq,
  BannerListRes,
  CreateBannerReq,
  ActionBannerRes,
  UpdateBannerReq,
  DeleteBannerReq,
  BannerDetailReq,
  BannerDetailRes,
} from './types'

export const getBannerListAction = createAsyncAction(
  'BANNER/GET_BANNER_LIST_REQ',
  'BANNER/GET_BANNER_LIST_SUCCESS',
  'BANNER/GET_BANNER_LIST_FAILURE',
)<BannerListReq, BannerListRes, Error>()

export const getBannerDetailAction = createAsyncAction(
  'BANNER/GET_BANNER_DETAIL_REQ',
  'BANNER/GET_BANNER_DETAIL_SUCCESS',
  'BANNER/GET_BANNER_DETAIL_FAILURE',
)<BannerDetailReq, BannerDetailRes, Error>()

export const createBannerAction = createAsyncAction(
  'BANNER/CREATE_BANNER_REQ',
  'BANNER/CREATE_BANNER_SUCCESS',
  'BANNER/CREATE_BANNER_FAILURE',
)<CreateMapping<CreateBannerReq>, ActionBannerRes, Error>()

export const updateBannerAction = createAsyncAction(
  'BANNER/UPDATE_BANNER_REQ',
  'BANNER/UPDATE_BANNER_SUCCESS',
  'BANNER/UPDATE_BANNER_FAILURE',
)<CreateMapping<UpdateBannerReq>, ActionBannerRes, Error>()

export const deleteBannerAction = createAsyncAction(
  'BANNER/DELETE_BANNER_REQ',
  'BANNER/DELETE_BANNER_SUCCESS',
  'BANNER/DELETE_BANNER_FAILURE',
)<DeleteBannerReq, ActionBannerRes, Error>()

export const clearEventAction = createStandardAction('BANNER/CLEAR_EVENT')<void>()
